// import React, { useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faClock,
//   faCalendar,
//   faUser,
//   faCheckCircle,
//   faNoteSticky,
//   faStar,
//   faClose,
// } from "@fortawesome/free-solid-svg-icons";
// import { formatDateVN, formatDateTime } from "../../../utils/formatUtils";

// import defaultAvatar from '../../../assets/images/avatar/employee-1.png';

// const OverTimeDetailModal = ({ isOpen, onClose, data }) => {
//   useEffect(() => {
//     if (!isOpen) return;
//     const handleKey = (e) => e.key === "Escape" && onClose();
//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [isOpen, onClose]);

//   if (!isOpen || !data) return null;

//   const STATUS_MAP = {
//     pending: { label: "Đăng ký", color: "bg-yellow-100 text-yellow-700" },
//     waiting_level_2: { label: "Chờ duyệt (Cấp 1)", color: "bg-yellow-200 text-yellow-800" },
//     waiting_report: { label: "Chờ báo cáo", color: "bg-blue-100 text-blue-700" },
//     waiting_review: { label: "Chờ đánh giá", color: "bg-indigo-100 text-indigo-700" },
//     approved: { label: "Phê duyệt", color: "bg-green-100 text-green-700" },
//     rejected: { label: "Không duyệt", color: "bg-red-100 text-red-700" },
//     completed: { label: "Hoàn thành", color: "bg-green-200 text-green-800" },
//   };

//   const st = STATUS_MAP[data.status] || STATUS_MAP["pending"];

//   return (
//     <div
//       className="fixed inset-0 bg-black/45 backdrop-blur-sm flex items-center justify-center z-[999]"
//       onClick={onClose}
//     >
//       <div
//         className="bg-white rounded-2xl shadow-2xl w-[500px] max-w-[95%] overflow-hidden border animate-[popupShow_0.25s_ease-out]"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* ================= HEADER ================= */}
//         <div className="px-6 py-4 flex justify-between items-center border-b">
//           <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
//             Chi tiết tăng ca
//           </h3>

//           <button onClick={onClose}>
//             <FontAwesomeIcon icon={faClose} className="text-gray-600" />
//           </button>
//         </div>

//         {/* ================= CONTENT ================= */}
//         <div className="px-6 py-5 space-y-6 max-h-[75vh] overflow-y-auto">

//           {/* ========== PHẦN 1: THÔNG TIN NHÂN VIÊN (THEO MẪU ẢNH) ========== */}
//           <div className="border rounded-xl p-4 bg-gray-50 shadow-sm space-y-4">
//             {/* Avatar + Info */}
//             <div className="flex gap-4 items-center">
//               <img
//                 src={data.employee_avatar || defaultAvatar}
//                 alt=""
//                 className="w-16 h-16 rounded-full border shadow-sm object-cover"
//               />
//               <div>
//                 <div className="text-[17px] font-semibold text-gray-900">
//                   {data.employee_name}
//                 </div>
//                 <div className="text-sm text-gray-600">
//                   {data.branch_name} • {data.department_name}
//                 </div>

//                 <span
//                   className={`mt-2 inline-block text-xs px-2 py-[3px] rounded-full font-semibold ${st.color}`}
//                 >
//                   {st.label}
//                 </span>
//               </div>
//             </div>

//             <div className="grid grid-cols-[24px_110px_1fr] gap-y-2 text-sm text-gray-800">

//               {/* Ngày làm việc */}
//               <div className="flex items-center">
//                 <FontAwesomeIcon icon={faCalendar} className="text-gray-500" />
//               </div>
//               <div className="font-medium text-gray-500">Ngày làm việc:</div>
//               <div className="font-semibold">{formatDateVN(data.work_date)}</div>

//               {/* Thời gian */}
//               <div className="flex items-center">
//                 <FontAwesomeIcon icon={faClock} className="text-gray-500 text-[13px]" />
//               </div>
//               <div className="font-medium text-gray-500">Thời gian:</div>
//               <div className="font-semibold">
//                 {data.ot_from?.slice(0, 5)} <span className="mx-1">→</span> {data.ot_to?.slice(0, 5)}
//               </div>

//               {/* Số giờ */}
//               <div className="flex items-center">
//                 <FontAwesomeIcon icon={faClock} className="text-gray-500 text-[13px]" />
//               </div>
//               <div className="font-medium text-gray-500">Số giờ:</div>
//               <div className="font-semibold">
//                 {(data.ot_minutes / 60).toFixed(2)} giờ
//               </div>

//               {/* Lý do */}
//               <div className="flex items-start">
//                 <FontAwesomeIcon icon={faNoteSticky} className="text-gray-500" />
//               </div>
//               <div className="font-medium text-gray-500">Lý do tăng ca:</div>
//               <div className="font-semibold">
//                 {data.reason || "-"}
//               </div>
//             </div>
//           </div>

//           {/* ========== PHẦN 2: THÔNG TIN PHÊ DUYỆT ========== */}
//           {data.status !== "pending" && data.status !== "cancelled" && (
//             <div className="border rounded-xl p-4 bg-white shadow-sm space-y-3">
//               <h3 className="font-semibold text-gray-800 flex items-center gap-2">
//                 <FontAwesomeIcon icon={faCheckCircle} className="text-green-600" />
//                 Thông tin phê duyệt
//               </h3>
              
//               <div className="space-y-1 text-sm">
//                 <div className="flex items-center gap-2 text-sm text-gray-800">
//                   <div className="font-medium text-gray-500">Người duyệt:</div>
//                   <div className="font-semibold">
//                     {data.approver_name || "-"}
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-2 text-sm text-gray-800">
//                   <div className="font-medium text-gray-500">Thời gian duyệt:</div>
//                   <div className="font-semibold">
//                     {formatDateTime(data.approved_at)}
//                   </div> 
//                 </div>              
//               </div>


//               {data.status === "rejected" && data.reject_reason && (
//                 <p className="text-red-600 text-sm">
//                   <b>Lý do từ chối:</b> {data.reject_reason}
//                 </p>
//               )}
//             </div>
//           )}

//           {/* ========== PHẦN 3: THÔNG TIN BÁO CÁO (DÙNG CHO EMPLOYEE SUBMIT) ========== */}
//           {(data.status === "waiting_review" || data.status === "completed") && (
//             <div className="border rounded-xl p-4 bg-gray-50 shadow-sm space-y-3">
//               <h3 className="font-semibold text-gray-800 flex items-center gap-2">
//                 <FontAwesomeIcon icon={faNoteSticky} className="text-blue-600" />
//                 Thông tin báo cáo
//               </h3>

//               <p className="text-sm">
//                 <b>Nội dung báo cáo:</b>{" "}
//                 {data.report_content || <i className="text-gray-400">Chưa có báo cáo</i>}
//               </p>

//               {data.report_file && (
//                 <a
//                   href={data.report_file}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-600 underline text-sm"
//                 >
//                   Mở file báo cáo
//                 </a>
//               )}
//             </div>
//           )}

//           {/* ========== PHẦN 4: KẾT QUẢ ĐÁNH GIÁ CUỐI ========== */}
//           {(data.status === "completed") && (
//             <div className="border rounded-xl p-4 bg-white shadow-sm space-y-3">
//               <h3 className="font-semibold text-gray-800 flex items-center gap-2">
//                 <FontAwesomeIcon icon={faStar} className="text-yellow-500" />
//                 Kết quả đánh giá
//               </h3>

//               <p className="text-sm">
//                 <b>Nhận xét:</b>{" "}
//                 {data.review_note || <i className="text-gray-400">Chưa có đánh giá</i>}
//               </p>

//               <p className="text-sm flex items-center gap-2">
//                 <b>Điểm:</b>
//                 {data.review_score ? (
//                   <span className="text-yellow-500 font-semibold">
//                     {"★".repeat(data.review_score)}
//                   </span>
//                 ) : (
//                   <i className="text-gray-400">Chưa chấm điểm</i>
//                 )}
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Animation */}
//       <style>{`
//         @keyframes popupShow {
//           0% { transform: scale(0.94); opacity: 0; }
//           100% { transform: scale(1); opacity: 1; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default OverTimeDetailModal;






















import React, { useEffect } from "react";
import { 
  X, Clock, Calendar, User, CheckCircle2, 
  FileText, Star, ShieldCheck, Timer, ExternalLink 
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { formatDateVN, formatDateTime } from "../../../utils/formatUtils";
import defaultAvatar from '../../../assets/images/avatar/employee-1.png';

const OverTimeDetailModal = ({ isOpen, onClose, data }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!data) return null;

  const STATUS_MAP = {
    pending: { label: "Đăng ký", color: "bg-amber-50 text-amber-600 border-amber-100" },
    waiting_level_2: { label: "Chờ duyệt (Cấp 1)", color: "bg-orange-50 text-orange-600 border-orange-100" },
    waiting_report: { label: "Chờ báo cáo", color: "bg-sky-50 text-sky-600 border-sky-100" },
    waiting_review: { label: "Chờ đánh giá", color: "bg-indigo-50 text-indigo-600 border-indigo-100" },
    approved: { label: "Phê duyệt", color: "bg-emerald-50 text-emerald-600 border-emerald-100" },
    rejected: { label: "Không duyệt", color: "bg-rose-50 text-rose-600 border-rose-100" },
    completed: { label: "Hoàn thành", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  };

  const st = STATUS_MAP[data.status] || STATUS_MAP["pending"];

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4">
          {/* Overlay mờ */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
          />

          {/* Modal Content */}
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            onClick={(e) => e.stopPropagation()}
            className="relative bg-white rounded-[2.5rem] shadow-2xl w-[550px] max-w-[95%] overflow-hidden border border-gray-100 flex flex-col max-h-[90vh]"
          >
            {/* ================= HEADER ================= */}
            <div className="p-8 pb-4 flex justify-between items-center bg-white">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center shadow-sm border border-red-100">
                  <Clock size={24} strokeWidth={2.5} />
                </div>
                <div>
                  <h2 className="text-xl font-black uppercase tracking-tight text-gray-800">Chi tiết tăng ca</h2>
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mt-0.5 italic">Hồ sơ lưu trữ IMA ERP</p>
                </div>
              </div>
              <button 
                onClick={onClose}
                className="p-2.5 bg-gray-50 hover:bg-gray-100 text-gray-400 hover:text-gray-600 rounded-2xl transition-all border border-gray-100"
              >
                <X size={20} strokeWidth={2.5} />
              </button>
            </div>

            {/* ================= CONTENT ================= */}
            <div className="px-8 pb-8 space-y-6 overflow-y-auto custom-scrollbar">

              {/* PHẦN 1: THÔNG TIN NHÂN VIÊN & TRẠNG THÁI */}
              <div className="p-5 bg-slate-50 rounded-[2rem] border border-slate-100 flex items-center gap-5">
                <div className="relative">
                  <img
                    src={data.employee_avatar || defaultAvatar}
                    className="w-20 h-20 rounded-[1.5rem] object-cover border-2 border-white shadow-md"
                    alt="avatar"
                  />
                  <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-emerald-500 rounded-full border-2 border-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-black text-gray-800 uppercase tracking-tight leading-tight truncate">
                    {data.employee_name}
                  </h3>
                  <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest mt-1">
                    {data.branch_name} • {data.department_name}
                  </p>
                  <span className={`mt-3 inline-flex items-center px-4 py-1 rounded-xl text-[10px] font-black uppercase tracking-wider border shadow-sm ${st.color}`}>
                    {st.label}
                  </span>
                </div>
              </div>

              {/* THÔNG TIN CHI TIẾT CÔNG VIỆC */}
              <div className="grid grid-cols-1 gap-3">
                {[
                  { icon: Calendar, label: "Ngày làm việc", value: formatDateVN(data.work_date), color: "text-blue-600" },
                  { icon: Clock, label: "Khoảng thời gian", value: `${data.ot_from?.slice(0, 5)} — ${data.ot_to?.slice(0, 5)}`, color: "text-red-600" },
                  { icon: Timer, label: "Tổng thời gian", value: `${(data.ot_minutes / 60).toFixed(2)} giờ`, color: "text-emerald-600" }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center justify-between p-4 bg-white border border-gray-50 rounded-2xl shadow-sm">
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-xl bg-gray-50 ${item.color}`}>
                        <item.icon size={18} />
                      </div>
                      <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">{item.label}</span>
                    </div>
                    <span className="text-sm font-black text-gray-700">{item.value}</span>
                  </div>
                ))}

                {/* Lý do tăng ca */}
                <div className="p-5 bg-amber-50/30 border border-amber-100/50 rounded-3xl space-y-2 mt-2">
                  <div className="flex items-center gap-2 text-[10px] font-black text-amber-600 uppercase tracking-widest">
                    <FileText size={14} /> Lý do đăng ký
                  </div>
                  <p className="text-sm text-amber-900 font-bold italic leading-relaxed">"{data.reason || "Không có lý do"}"</p>
                </div>
              </div>

              {/* PHẦN 2: THÔNG TIN PHÊ DUYỆT */}
              {data.status !== "pending" && data.status !== "cancelled" && (
                <div className="p-5 bg-white border border-gray-100 rounded-[1.5rem] space-y-4">
                  <h3 className="text-[11px] font-black text-gray-400 uppercase tracking-[0.2em] flex items-center gap-2">
                    <ShieldCheck size={16} className="text-emerald-600" /> Thông tin phê duyệt
                  </h3>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Người duyệt</p>
                      <p className="text-sm font-black text-gray-800 uppercase italic truncate">{data.approver_name || "-"}</p>
                    </div>
                    <div>
                      <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Ngày giờ duyệt</p>
                      <p className="text-sm font-black text-gray-800">{formatDateTime(data.approved_at)}</p>
                    </div>
                  </div>

                  {data.status === "rejected" && data.reject_reason && (
                    <div className="p-3 bg-rose-50 rounded-xl border border-rose-100 text-rose-700 text-xs font-bold italic">
                      Lý do từ chối: {data.reject_reason}
                    </div>
                  )}
                </div>
              )}

              {/* PHẦN 3: THÔNG TIN BÁO CÁO CÔNG VIỆC */}
              {(data.status === "waiting_review" || data.status === "completed") && (
                <div className="p-5 bg-blue-50/30 border border-blue-100/50 rounded-[1.5rem] space-y-4">
                  <h3 className="text-[11px] font-black text-blue-500 uppercase tracking-[0.2em] flex items-center gap-2">
                    <CheckCircle2 size={16} /> Báo cáo thực hiện
                  </h3>

                  <p className="text-sm font-bold text-slate-700 leading-relaxed italic">
                    "{data.report_content || "Chưa có nội dung báo cáo"}"
                  </p>

                  {data.report_file && (
                    <div className="flex items-center gap-3 p-3 bg-white rounded-xl border border-blue-100 shadow-sm overflow-hidden">
                      <div className="w-10 h-10 rounded-lg bg-red-50 text-red-600 flex items-center justify-center font-black text-[10px]">PDF</div>
                      <div className="flex-1 min-w-0">
                        <div className="font-black text-gray-800 text-[11px] truncate uppercase tracking-tighter">File minh chứng đính kèm</div>
                        <a
                          href={data.report_file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 font-black text-[10px] uppercase tracking-widest flex items-center gap-1 mt-1 hover:underline"
                        >
                          <ExternalLink size={10} /> Mở tệp tin
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* PHẦN 4: KẾT QUẢ ĐÁNH GIÁ CUỐI */}
              {(data.status === "completed") && (
                <div className="p-5 bg-slate-50 border border-slate-100 rounded-[2rem] space-y-4">
                  <h3 className="text-[11px] font-black text-yellow-600 uppercase tracking-[0.2em] flex items-center gap-2">
                    <Star size={16} className="fill-yellow-500 text-yellow-500" /> Đánh giá cuối cùng
                  </h3>

                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Nhận xét</span>
                      <span className="text-sm font-black text-gray-700 italic">
                        {data.review_note || "Chưa có đánh giá"}
                      </span>
                    </div>

                    <div className="flex items-center justify-between">
                      <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Chấm điểm</span>
                      <div className="flex items-center gap-2">
                        {data.review_score ? (
                          <div className="flex items-center gap-1">
                            {[...Array(5)].map((_, i) => (
                              <Star 
                                key={i} 
                                size={14} 
                                className={`${i < data.review_score ? "fill-yellow-500 text-yellow-500" : "text-slate-200"}`} 
                              />
                            ))}
                            <span className="ml-2 w-8 h-8 rounded-lg bg-white border border-slate-200 flex items-center justify-center font-black text-slate-700 text-xs shadow-sm">
                              {data.review_score}
                            </span>
                          </div>
                        ) : (
                          <i className="text-gray-400 text-xs italic">Chưa chấm điểm</i>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            {/* Footer */}
            <div className="p-8 pt-4 bg-gray-50/50 flex justify-end border-t border-gray-50">
               <button 
                  onClick={onClose}
                  className="px-10 py-4 bg-white border border-gray-100 hover:bg-gray-50 text-gray-500 font-black text-[11px] uppercase tracking-widest rounded-2xl shadow-sm transition-all active:scale-95"
                >
                  Đóng hồ sơ
                </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default OverTimeDetailModal;